import { toast } from 'react-toastify'
import { NEWS, SALES } from '../constant/routes'

interface Types {
  url: string
  token: string | null
  formData: FormData
  setIsFormLoading: (value: boolean) => void
  mutate: (value: string) => void
  destroyToken: () => void
  history: { push: (value: string) => void }
  onResetHandler?: () => void
}

export const createResource = async ({
  url,
  token,
  formData,
  setIsFormLoading,
  mutate,
  destroyToken,
  history,
  onResetHandler,
}: Types) => {
  const resource = url.startsWith('news/article') ? 'Το άρθρο' : 'Η προσφορά'

  try {
    const response = await fetch(`${process.env.REACT_APP_API_HOST}/api/${url}/`, {
      method: 'POST',
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (response.ok) {
      toast.success(`${resource} δημιουγήθηκε επιτυχώς`)
      setIsFormLoading(false)
      mutate(url.startsWith('news/article') ? 'news/article' : 'offers/offer')
      history.push(url.startsWith('news/article') ? NEWS.main : SALES.main)
    }

    if (response.ok && onResetHandler) {
      onResetHandler()
    }

    if (response.status === 401) {
      destroyToken()
      throw new Error('Η σύνδεση σας έχει λήξει. Παρακαλώ συνδεθείτε ξανά.')
    }

    if (!response.ok) {
      throw new Error(`Αποτυχία δημιουργίας εγγραφής. Παρακαλώ δοκιμάστε ξανά.`)
    }
  } catch (err) {
    if (err instanceof Error) {
      toast.error(err.message)
    }
    setIsFormLoading(false)
  }
}
